// app/error.js
"use client";

import React from "react";
import Image from "next/image";

export default function Error({ error, reset }) {
  return (
    <div class="bg-metaxseed-dark-gray text-white h-screen w-screen flex flex-col items-center justify-center">
      <div class="text-center p-6 max-w-lg mx-auto">
        <div class="flex justify-center">
          <a href="/">
            <Image
              src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
              alt="mxs-logo"
              class="h-16 w-16"
              width={64}
              height={64}
            />
          </a>
        </div>
        <p class="text-2xl mt-2">Something went wrong</p>
        <p class="text-metaxseed-text-gray mt-4">
          Oops! Something went wrong. Please try refreshing the page or
          navigating back to the homepage. If the problem persists, please
          contact support.
        </p>
        <div class="mt-8">
          <a
            href="/"
            class="px-6 py-3 text-lg font-semibold rounded bg-metaxseed-orange text-white transition-all duration-300 hover:bg-metaxseed-orange-dark"
          >
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}
